import { useState } from 'react';

import classNames from 'classnames';
import axios from 'axios';
import { InputNew, Button, TextareaNew, SelectNew, SelectPackage, SelectSolutions } from '../../../ui';
import OfferModal from './OfferModal';

const OfferForm = props => {
  const { className, country } = props;

  const [values, setValues] = useState({
    firstName: '',
    telegram: '',
    phoneNumber: '',
    companyName: '',
    email: '',
    message: '',
    solutions: '',
    package: '',
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [isThanksOpen, setIsThanksOpen] = useState(false);

  const validate = () => {
    const newErrors = {};

    if (!values.firstName) newErrors.firstName = 'Required field is missing or incorrectly filled';
    if (!values.telegram) newErrors.telegram = 'Required field is missing or incorrectly filled';
    if (!values.email) newErrors.email = 'Required field is missing or incorrectly filled';
    if (!values.companyName) newErrors.companyName = 'Required field is missing or incorrectly filled';
    if (!values.package) newErrors.package = 'Required field is missing or incorrectly filled';
    if (!values.solutions) newErrors.solutions = 'Required field is missing or incorrectly filled';
    else if (!emailValidation(values.email)) newErrors.email = 'Invalid email format';

    return newErrors;
  };

  const handleChange = e => {
    const { name, value } = e.target;

    setLoading(false);
    setErrors({ ...errors, [name]: '' });

    setValues({
      ...values,
      [name]: value,
    });
  };

  const handleSubmit = e => {
    e.preventDefault();
    setLoading(true);

    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const formData = new FormData();

    for (let key in values) {
      formData.append(key, values[key]);
    }

    formData.append('country', country);
    formData.append('service', `Request from ${values.firstName}`);

    console.log(Array.from(formData));

    axios.post('https://mailer.weprodigi.com/api/v1/world-cup-2026', formData).then(response => {
      setLoading(false);
      setValues({ firstName: '', telegram: '', phoneNumber: '', companyName: '', email: '', message: '', package: '', solutions: '' });
      setIsThanksOpen(true);
    });
  };

  const emailValidation = email => {
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    if (!email || regex.test(email) === false) {
      return false;
    }
    return true;
  };

  return (
    <div className="relative">
      <form onSubmit={handleSubmit} className={classNames('flex flex-col gap-[16px]', className)}>
        <div className="flex lg:flex-row flex-col gap-[16px]">
          <div className="w-full lg:w-1/2">
            <InputNew
              label="First Name"
              isRequired={true}
              name="firstName"
              placeholder="First Name"
              value={values.firstName}
              error={errors.firstName}
              onChange={handleChange}
            />
          </div>
          <div className="w-full lg:w-1/2">
            <InputNew
              label="Telegram"
              isRequired={true}
              name="telegram"
              placeholder="Telegram"
              value={values.telegram}
              error={errors.telegram}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="flex lg:flex-row flex-col gap-[16px]">
          <div className="w-full lg:w-1/2">
            <InputNew
              label="Company"
              isRequired={true}
              name="companyName"
              placeholder="Company"
              value={values.companyName}
              error={errors.companyName}
              onChange={handleChange}
            />
          </div>
          <div className="w-full lg:w-1/2">
            <InputNew
              label="Email"
              name="email"
              type="email"
              placeholder="Email"
              isRequired={true}
              value={values.email}
              error={errors.email}
              onChange={handleChange}
            />
          </div>
        </div>
        <div className="flex lg:flex-row flex-col gap-[16px]">
          <div className="w-full lg:w-1/2">
            <SelectPackage
              name="package"
              placeholder="Select package"
              value={values.package}
              onChange={handleChange}
              isRequired={true}
              error={errors.package}
            />
          </div>
          <div className="w-full lg:w-1/2">
            <SelectSolutions
              name="solutions"
              placeholder="Select solution"
              value={values.solutions}
              onChange={handleChange}
              isRequired={true}
              error={errors.solutions}
            />
          </div>
        </div>
        <div className="flex flex-col gap-[16px] w-full">
          <InputNew
            label="Phone Number"
            isRequired={false}
            name="phoneNumber"
            placeholder="+XX 000 000 000"
            value={values.phoneNumber}
            onChange={handleChange}
            className="w-full"
          />
          <div className="flex flex-col gap-[16px] w-full ">
            <p className="md:text-[18px] text-[16px] font-[500] leading-[20px] text-white">Message</p>
            <TextareaNew
              name="message"
              placeholder="Tell us about your campaign goals, geos, or any question...."
              value={values.message}
              onChange={handleChange}
            />
          </div>
          <div className="flex flex-col md:gap-[16px] gap-[16px] w-full  relative">
            <div className="flex items-center justify-center">
              <Button type="submit" variant="transparentWorld" className="w-full">
                {loading && (
                  <svg viewBox="0 0 200 200" width="20" height="20" xmlns="http://www.w3.org/2000/svg">
                    <defs>
                      <linearGradient id="pl-grad1" x1="1" y1="0.5" x2="0" y2="0.5">
                        <stop offset="0%" stopColor="hsl(313,90%,55%)" />
                        <stop offset="100%" stopColor="hsl(223,90%,55%)" />
                      </linearGradient>
                      <linearGradient id="pl-grad2" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="hsl(313,90%,55%)" />
                        <stop offset="100%" stopColor="hsl(223,90%,55%)" />
                      </linearGradient>
                    </defs>
                    <circle
                      className="pl__ring"
                      cx="100"
                      cy="100"
                      r="82"
                      fill="none"
                      stroke="url(#pl-grad1)"
                      strokeWidth="36"
                      strokeDasharray="0 257 1 257"
                      strokeDashoffset="0.01"
                      strokeLinecap="round"
                      transform="rotate(-90,100,100)"
                    />
                    <line
                      className="pl__ball"
                      stroke="url(#pl-grad2)"
                      x1="100"
                      y1="18"
                      x2="100.01"
                      y2="182"
                      strokeWidth="36"
                      strokeDasharray="1 165"
                      strokeLinecap="round"
                    />
                  </svg>
                )}
                Send request
              </Button>
            </div>
          </div>
        </div>
      </form>
      {isThanksOpen && <OfferModal />}
    </div>
  );
};

export default OfferForm;
